import CUSTOM_SVG from './CustomConnectionSVG';
import HUBSPOT from './hubspot-icon.png';
import HUBSPOT_OVERVIEW from './hubspot-logo.png';
import SHOPIFY_OVERVIEW from './shopify-logo.png';
import XERO from './xero-icon.png';

export default {
    CUSTOM_SVG,
    HUBSPOT,
    HUBSPOT_OVERVIEW,
    SHOPIFY_OVERVIEW,
    XERO
};
